import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';

export default function AdminLoader() {
  const [progress, setProgress] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box style={{ paddingTop: '7px' }}>
      <LinearProgress
        variant='determinate'
        value={progress}
        sx={{
          backgroundColor: '#e0f2e1', // Light green background (theme primary.light at 10% opacity)
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#1a5f23', // Primary green for the progress bar
          },
        }}
      />
    </Box>
  );
}
